var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{staticClass:"empty:hidden",attrs:{"size":"small"}},[(!!_vm.cta.url && !!_vm.cta.label)?_c('section',{staticClass:"col-span-full flex justify-center",attrs:{"data-t-name":"location_online_appointment"}},[_c('BaseCta',{attrs:{"id":_vm.anchorName,"link":_vm.cta}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }